const worksData = {
  roomCleaning: {
    works:
      "Room Cleaning: Our website offers support for keeping your room clean and tidy. We understand that living in a hostel can be challenging, and we want to make it as easy as possible for you to maintain a clean and comfortable living space. Our team is dedicated to providing you with the necessary resources and assistance to ensure your room is always clean.",
  },
  electrician: {
    works:
      "Electricity problems: Electrical problems can be a major inconvenience, and our website is here to help. We offer support for resolving any issues you may be experiencing with your electricity, whether it's a blown fuse or a more complex problem. Our team of experts is dedicated to ensuring that you have access to reliable and safe electricity at all times.",
  },
  plumber: {
    works:
      "Water problems: If you are experiencing problems with your water supply, our website is here to help. We understand the importance of having access to clean and safe water, and we will work with you to resolve any issues you may be facing. Whether it's a leaky faucet or a more serious issue, our team is ready to assist you.",
  },
  carpenter: {
    works:
      "Furniture problems: Our website offers support for resolving any issues you may be experiencing with your furniture. Whether it's a broken chair or a loose screw, our team is here to help. We understand the importance of having comfortable and functional furniture, and we will work with you to ensure that your furniture is in top condition at all times.",
  },
  food: {
    works:
      "Food problems: Our website offers support for resolving any issues you may be experiencing with your food. Whether it's a contaminated product or a cooking mistake, our team is here to help. We understand the importance of having safe and delicious food, and we will work with you to ensure that your food is of the highest quality at all times.",
  },
  ragging: {
    works:
      "Ragging problems: Our website offers support for resolving any issues you may be experiencing with ragging. Whether it's physical or mental harassment, our team is here to help. We understand the importance of providing a safe and respectful environment for everyone, and we will work with you to ensure that ragging does not occur on our campus.",
  },
};

export default worksData;
